import { DestroyRef, Injectable } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Router } from '@angular/router'
import { Apollo } from 'apollo-angular'
import { BehaviorSubject, combineLatest, distinctUntilChanged, fromEvent, map, merge, Observable, of, tap } from 'rxjs'
import { PusherLink } from '../../links/pusher.link'

@Injectable({
    providedIn: 'root',
})
export class ConnectionService {

    private networkStatus: boolean = false
    public networkStatus$: Observable<any>
    private connectionStatus$ = new BehaviorSubject<boolean>(false)


    constructor(
        private destroyRef: DestroyRef,
        private apollo: Apollo,
        private router: Router,
    ) {
    }

    public async initialize() {
        this.networkStatus = navigator.onLine

        const link = this.apollo.client.link

        if (link.left instanceof PusherLink) {
            const pusher = (link.left as any).pusher

            if (pusher) {
                pusher.connection.bind('connected', () => this.connectionStatus$.next(true))
                pusher.connection.bind('disconnected', () => this.connectionStatus$.next(false))
            }
        }

        this.networkStatus$ = combineLatest({
            internet: merge(
                of(navigator.onLine),
                fromEvent(window, 'online').pipe(map(() => true)),
                fromEvent(window, 'offline').pipe(map(() => false)),
            ),
            websocket: this.connectionStatus$.pipe(),
        }).pipe(
            takeUntilDestroyed(this.destroyRef),
            distinctUntilChanged(),
            tap(({internet, websocket}) => {
                if (! internet && websocket) {
                    this.router.navigate(['/no-connection'])
                } else {
                    this.router.navigate(['/'])
                }
            }),
            map(
                ({ internet, websocket }) => (internet && websocket),
            ))

    }
}
